import Vapi from 'vuex-rest-api';

const fetcherPost = new Vapi({
  state: {
    fetcherPost: {
      pid: 0,
    },
  },
})
  .get({
    action: 'getFetcherPost',
    property: 'fetcherPost',
    path: ({ pid }) => `/api/fetcher/posts/${pid}`,
  })
  .getStore();

export default fetcherPost;
